$(document).ready(function(){
    if(window.location.hash.indexOf('#opencartdrawer') > -1) {
        document.querySelector('[aria-controls="cart-drawer"]')?.click();
        const url = window.location.href.replace("#opencartdrawer", "");
        history.replaceState(null, null, url);
    } 
    function formatMoney(cents, format = "") {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || window.themeVariables.settings.moneyFormat;
        function defaultTo(value2, defaultValue) {
            return value2 == null || value2 !== value2 ? defaultValue : value2;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");
            if (isNaN(number) || number == null) {
            return 0;
            }
            number = (number / 100).toFixed(precision);
            let parts = number.split("."),
            dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands
            ),
            centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
        }
        let value = "";
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
            case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
            case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
            case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
            case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
            case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
            case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
            case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
        }
        if (formatString.indexOf("with_comma_separator") !== -1) {
            return formatString.replace(placeholderRegex, value);
        } else {
            return formatString.replace(placeholderRegex, value);
        }
    }
    var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
    ? window.themeVariables.settings.moneyWithCurrencyFormat
    : window.themeVariables.settings.moneyFormat;

    $('body').on('keyup','#coupon_code_input', function(){
        if($(this).val().length > 0){
        $(this).closest('.cart-coupon_offer-input').find('.offer_button').addClass('active');
        }else{
        $(this).closest('.cart-coupon_offer-input').find('.offer_button').removeClass('active');
        }
    });

    function existingDiscounts(){
        const discountCodes = [];
        const discountPills = $('.applied_codes').find('.code_block');
        for (const pill of discountPills) {
        if (typeof $(pill).attr('data-discount-code') === 'string') {
            discountCodes.push($(pill).attr('data-discount-code'));
        }
        }
        
        return discountCodes;
    }

    $('body').on('click','[data-inputapply]', function(){
        $('.offer_input_err').remove();
        $(this).closest('[is="loader-button"]').addClass('loading');
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:start", { bubbles: true })
        );
        var _this = $(this);
        var sectionId = _this.closest('cart-drawer').attr('section');
        var discountCodeValue = _this.closest('.cart-coupon_offer-input').find('#coupon_code_input').val();
        if(discountCodeValue == ''){
            _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Please enter any code above.</p>');
            $(this).closest('[is="loader-button"]').removeClass('loading');
            document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true })
            );
            return;
        }
        var existingDiscountsValue = existingDiscounts();
        
        if (existingDiscountsValue.includes(discountCodeValue)) return;
        
        async function getupdatedata(){     
            let response = await fetch(`${window.themeVariables.settings.cart_update_url}.js`, {
                method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
                headers : {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    discount: [...existingDiscountsValue, discountCodeValue].join(','),
                    sections: [sectionId]
                })
            });
            const data = await response.json();
            return data;
        }
        getupdatedata().then(data => {
            console.log(data);
            if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
                return discount.code === discountCodeValue && discount.applicable === false;
            })
        ) {
            _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Invalid coupon code. Try again.</p>');
            _this.closest('[is="loader-button"]').removeClass('loading');
            document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true })
            );
            return;
        }

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
            cart: data
            }
        }));
        
        _this.closest('[is="loader-button"]').removeClass('loading');
        document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
        );
        });
    });

    $('body').on('click','[data-removecode]', function(){
        $(this).closest('.code_block').addClass('loading');
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:start", { bubbles: true })
        );
        var sectionId = $(this).closest('cart-drawer').attr('section');
        var discountCodeValue = $(this).closest('.code_block').attr('data-discount-code');
        var existingDiscountsValue = existingDiscounts();
        
        const index = existingDiscountsValue.indexOf(discountCodeValue);
        if (index === -1){
            $(this).closest('.code_block').removeClass('loading');
            return;
        } 

        existingDiscountsValue.splice(index, 1);
        
        async function getupdatedata(){     
            let response = await fetch(`${window.themeVariables.settings.cart_update_url}.js`, {
                method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
                headers : {
                "Content-Type": "application/json"
                },
                body: JSON.stringify({ 
                discount: existingDiscountsValue.join(','),
                sections: [sectionId]
                })
            });
            const data = await response.json();
            return data;
        }
        getupdatedata().then(data => {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                cart: data
                }
            }));
            $(this).closest('.code_block').removeClass('loading');
            document.documentElement.dispatchEvent(
                new CustomEvent("theme:loading:end", { bubbles: true })
            );
        });
    });

    $('body').on('click','.discount-price-wrapper .total_price_main', function(){
        if($(this).hasClass('active')){
        $(this).removeClass('active');
        $(this).closest('.discount-price-wrapper').find('.payment-summary-list').slideUp();
        }else{
        $(this).addClass('active');
        $(this).closest('.discount-price-wrapper').find('.payment-summary-list').slideDown();
        }
    });

    $('body').on('click','[data-cart-atc]', function(e){
        e.preventDefault();
        var _this = $(this);
        $(this).addClass('loading');
        console.log('innnn')
        var items = [];
        items.push({
            quantity: 1,
            id: $(this).attr('data-vid')
        });
        
        var data = {items};
        console.log(data);
        fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(function(data) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                cart: data
                }
            }));
            _this.removeClass('loading');
        }.bind(this));  
    });

    $('body').on('click','.bundle_variants_list .quantity-selector__button', function(e){
        var _this = this;
        var qtylimit = parseInt($(_this).closest('.bundle_variants_list').attr('data-qtylimit'));
        
        var input = $(this).closest('.quantity-selector').find('[name="quantity"]');
        if($(this).hasClass('plus_icon')){
            if($(_this).hasClass('limitcrossed')){
                alert('You’ve hit the '+qtylimit+' pad quantity limit! Try removing one to add another. ✨');
                return;
            }
            input.val(parseInt(input.val()) + 1);    
        }else{
            input.val(parseInt(input.val()) - 1);
        }
        if(input.val() == 0){
            $(this).closest('.quantity-selector').find('.minus_icon').attr('disabled','disabled');
        }else{
            $(this).closest('.quantity-selector').find('.minus_icon').removeAttr('disabled');
        }
        
        var totalqty = 0;
        var totalprice = 0;
        var totalcompprice = 0;
        $(_this).closest('.variant_list_flex').find('.bundle_variant_item').each(function(i,e){
            if(parseInt($(this).find('[name="quantity"]').val()) > 0){
                totalqty += parseInt($(this).find('[name="quantity"]').val());
                totalprice += parseInt($(this).attr('data-varprice')) * parseInt($(this).find('[name="quantity"]').val());
                totalcompprice += parseInt($(this).attr('data-varcompprice')) * parseInt($(this).find('[name="quantity"]').val());
            }else{
                totalprice += 0;
                totalcompprice += 0;
            }
        });
        var stickypricehtml = '<sale-price class="h4 text-on-sale">'+ formatMoney(totalprice, currencyFormat) +'</sale-price>';
        var pricehtml = '<sale-price class="h4 text-on-sale">'+ formatMoney(totalprice, currencyFormat) +'</sale-price>';

        if(totalprice < totalcompprice){
            stickypricehtml += '<compare-at-price class="h5 text-subdued line-through">'+formatMoney(totalcompprice, currencyFormat) +'</compare-at-price>'
            pricehtml += '<compare-at-price class="h5 text-subdued line-through">'+formatMoney(totalcompprice, currencyFormat) +'</compare-at-price>';

            const saving = ((totalcompprice - totalprice) * 100) / totalcompprice;
            const roundedNumber = Math.round(saving) + '% OFF';
            pricehtml += '<div class="percent-off text-product-fs">'+roundedNumber+'</div>';
            stickypricehtml += '<div class="percent-off text-product-fs">'+roundedNumber+'</div>';
        }

        $(_this).closest('.product-info').find('.product-info__block-item:is([data-block-type=price]) .price-list').html(pricehtml);
        $('product-sticky-bar').find('.price-list').html(stickypricehtml);
        if(totalprice > 0){
            $(_this).closest('.product-info').find('.product-info__block-item:is([data-block-type=price])').show();
            $('product-sticky-bar').find('.price-list').show();
        }else{
            $(_this).closest('.product-info').find('.product-info__block-item:is([data-block-type=price])').hide();
            $('product-sticky-bar').find('.price-list').hide();
        }
        var formid = $(_this).closest('.quantity-selector').attr('data-form');
        if(totalqty == qtylimit){
            $(_this).closest('.variant_list_flex').find('.quantity-selector .plus_icon').addClass('limitcrossed');
            $('.buy-buttons[form="'+formid+'"] button').removeClass('disabled').removeAttr('disabled').attr('type','submit').find('.btn_text').text($('.buy-buttons[form="'+formid+'"] button').attr('data-buttontext'));
        }else{
            console.log('elsss')
            $(_this).closest('.variant_list_flex').find('.quantity-selector .plus_icon').removeClass('limitcrossed');
            $('.buy-buttons[form="'+formid+'"] button').addClass('disabled').attr('disabled','disabled').attr('type','button').find('.btn_text').text($('.buy-buttons[form="'+formid+'"] button').attr('data-defaulttext'));
            $(_this).closest('.variant_list_flex').find('.bundle_variant_item .quantity-selector .quantity-selector__button:last-child').removeAttr('disabled');
        }
    });

    $('body').on('click','[data-bundleatc]', async function(e){
        e.preventDefault();
        var _this = $(this);
        $(this).addClass('loading');
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:start", { bubbles: true })
        );

        var uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
        var cnnt = 0;
        let items = [];

        $('.bundle_variants_list .bundle_variant_item').each(function(){
            cnnt += 1;
            let qty = parseInt($(this).find('[name="quantity"]').val());

            if(qty > 0){
                if(cnnt == 1){
                    var _itemtype = 'mainitem';
                }else{
                    var _itemtype = 'subitem';
                }                
                items.push({
                    quantity: qty,
                    id: $(this).attr('data-vid'),
                    properties: {
                      '_bundleid': uid,
                      '_itemtype': _itemtype,
                      '_baseqty': parseInt(qty)
                    }
                });
            }
        });

        if(items.length === 0) return;

        let sectionsToRender = [];

        // ✅ collect sections (VERY IMPORTANT)
        document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: { sections: sectionsToRender },
            })
        );

        try {
            let response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify({
                items: items,
                sections: sectionsToRender.join(',')
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
            });

            let data = await response.json();
            console.log('Response:', data);

            if (response.ok) {
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "variant:add",
                        cart: data
                    }
                }));
            }else{
                console.log('ininininnii')
                var errorbannerhtml = `<div class="banner banner--error" role="alert" aria-live="polite">
                    ${data["description"]}
                </div>`;
                _this.before(errorbannerhtml);
                setTimeout(function(){
                    $('.banner.banner--error').remove();
                },2000);
            }
            document.dispatchEvent(new CustomEvent("cart:refresh"));

            
            document.documentElement.dispatchEvent(
                new CustomEvent("theme:loading:end", { bubbles: true })
            );
            $(this).removeClass('loading');

        } catch (error) {
            console.error('Error:', error);
        }
    });

    function initAnnouncement(){

        var wrapper = $('.announcement-bar .bar_content_wrapper');
        var messages = wrapper.find('.bar_message');
        var count = messages.length;
        var width = $(window).width();

        wrapper.removeClass('marquee center');

        if(width <= 768){

        wrapper.addClass('marquee');

        if(wrapper.find('.duplicate').length == 0){
            wrapper.append(messages.clone().addClass('duplicate'));
        }

        }else{

        if(count > 1){

            wrapper.addClass('marquee');

            if(wrapper.find('.duplicate').length == 0){
            wrapper.append(messages.clone().addClass('duplicate'));
            }

        }else{

            wrapper.addClass('center');

        }

        }

    }

    initAnnouncement();

    $(window).on('resize', function(){
        initAnnouncement();
    });

    $('body').on('click','.bundle_lineitem_aside .bundle_remove_link', function(){
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:start", { bubbles: true })
        );
        var __this = this;
        $(__this).addClass('loading');
        var listupdateData = {};
        $(this).closest('.linebundle_wrapper').find('.line-item').each(function(i,e){
            listupdateData[$(e).attr('data-lineid')] = 0;
        });
        if (Object.keys(listupdateData).length != 0) {
            $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: {
                    updates: listupdateData
                },
                dataType: 'json',
                success: function(data) {                
                    console.log(data);
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                    document.documentElement.dispatchEvent(
                        new CustomEvent("theme:loading:end", { bubbles: true })
                    );
                    $(__this).removeClass('loading');
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR);
                }
            });
        }
    });

});


document.querySelector('.product-info').addEventListener('toggle', function(e) {
  if (e.target.tagName !== 'DETAILS' || !e.target.open) return;
  document.querySelectorAll('.product-info accordion-disclosure details[open]').forEach(function(el) {
    if (el !== e.target) {
      el.removeAttribute('open');
      el.setAttribute('aria-expanded', 'false');
    }
  });
}, true); // capture phase needed since 'toggle' doesn't bubble